import { EventParticipantTicket } from 'src/modules/event/models/eventParticipantTicket';
import { EventParticipantTicketRequest, EventParticipantTicketUpdateRequest } from 'src/modules/event/models/eventParticipantTicketRequest';
import { EventParticipantTicketSearchFilter } from 'src/modules/event/models/eventParticipantTicketSearchFilter';
import { PagedResult } from '../models/pagedResult';
import AxiosInstance from './axios/interceptor';
import { setPagingParams } from '../functions/createPagingParams';
import { setArrayValue } from '../functions/setArrayValue';

const controller = 'EventParticipantTicket';

export const getAllEventParticipantTickets = (pageIndex, pageSize, sortCol, sortDir, searchFilter?: EventParticipantTicketSearchFilter) => {
  let extraQuery = '';

  if (searchFilter) {
    extraQuery += searchFilter.searchString ? `&filter=${searchFilter.searchString}` : '';
    extraQuery += setArrayValue(
      searchFilter.selectedTicketTypes?.map((type) => type.id),
      'eventTicket_id',
    );
  }
  const endpoint = `${controller}/?${setPagingParams({ pageIndex, pageSize, sortCol, sortDir })}${extraQuery}`;
  return AxiosInstance.get<PagedResult<EventParticipantTicket>>(endpoint);
};

export const getEventParticipantTicketById = (id) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.get<EventParticipantTicket>(endpoint);
};

export const createEventParticipantTicket = (data: EventParticipantTicketRequest) => {
  return AxiosInstance.post(controller, data);
};

export const updateEventParticipantTicket = (data: EventParticipantTicketUpdateRequest) => {
  return AxiosInstance.put<EventParticipantTicket>(controller, data);
};

export const redeemEventParticipantTicket = (id: number) => {
  return AxiosInstance.put<EventParticipantTicket>(`${controller}/${id}/RedeemTicket`);
};

export const deleteEventParticipantTicketById = (id) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.delete(endpoint);
};
export const deleteEventParticipantTicketsList = (ids: number[]) => {
  const endpoint = `${controller}/DeleteList`;
  return AxiosInstance.delete(endpoint, { data: ids });
};
